import React from "react";
import { isBrowser } from "../util/browser";

interface RedirectParams {
  href: string;
}

export function RedirectTo({ href }: RedirectParams): JSX.Element {
  if (isBrowser()) {
    window.location.href = href;
  }
  return <></>;
}
